<template>
  <div class="top-navbar" :class="navbarClass">
    <div class="navbar-content">
      <!-- Left side - Hamburger menu for mobile -->
      <div class="navbar-left">
        <feather-icon
          icon="MenuIcon"
          class="hamburger-menu cursor-pointer"
          @click.stop="toggleSidebar"
        ></feather-icon>
      </div>

      <!-- Right side - Profile, Notifications, Language -->
      <div class="navbar-right">
        <!-- Language Switcher -->
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer mr-5">
          <div class="con-img ml-3">
            <img
              :src="getCurrentLocaleData.flag"
              alt="user-img"
              width="30"
              height="30"
              class="rounded-full shadow-md cursor-pointer block" />
          </div>
          <vs-dropdown-menu>
            <ul style="min-width: 9rem">
              <li
                v-for="lang in languages"
                :key="lang.locale"
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                @click="updateLocale(lang.locale)">
                <img
                  :src="lang.flag"
                  alt="us"
                  width="20"
                  height="20"
                  class="rounded-full shadow-md cursor-pointer block" />
                <span class="ml-2">{{ lang.lang }}</span>
              </li>
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- Notifications Bell -->
        <vs-dropdown
          v-if="getRolePermission().alert.alert_history.access_to_alert"
          vs-custom-content
          vs-trigger-click
          class="cursor-pointer"
          color="danger">
          <feather-icon
            icon="BellIcon"
            class="cursor-pointer mt-1 sm:mr-6 mr-2"
            :badge="counter"></feather-icon>
          <vs-dropdown-menu
            class="notification-dropdown dropdown-custom dropdown-red"
            color="danger">
            <div class="notification-top text-center p-5 bg-primary text-white" style="background: linear-gradient(135deg, rgba(238, 109, 109, 1) 0%, rgba(238, 109, 109, 0.8) 100%) !important; color: white !important;">
              <h3 class="text-white" style="color: white !important;">{{ counter }} Unread</h3>
              <p class="opacity-75" style="color: white !important;">{{ $t('Vehicle Notifications') }}</p>
              <div class="mt-2">
                <vs-button
                  v-if="data_notif.length > 0"
                  size="small"
                  color="white"
                  type="border"
                  @click="markAllAsRead"
                  class="text-xs"
                  :disabled="markingAsRead">
                  {{ markingAsRead ? 'Marking...' : 'Tandai telah dibaca' }}
                </vs-button>
              </div>
            </div>

            <VuePerfectScrollbar
              ref="mainSidebarPs"
              class="scroll-area--nofications-dropdown p-0 mb-10"
              :settings="settings">
              <ul class="bordered-items">
                <li
                  v-for="ntf in data_notif"
                  :key="ntf._id"
                  class="flex justify-between px-4 py-4 notification"
                  :class="{ 'notification-read': ntf.is_read }"
                  style="position: relative">
                  <div class="flex items-start">
                    <feather-icon
                      class="cursor-pointer"
                      @click="$router.push('/alert-history')"
                      icon="AlertTriangleIcon"
                      :svgClasses="[
                        `text-danger`,
                        'stroke-current mr-1 h-6 w-6',
                        { 'opacity-50': ntf.is_read }
                      ]"></feather-icon>
                    <div
                      @click="$router.push('/alert-history')"
                      class="mx-2 cursor-pointer">
                      <span
                        class="font-medium block notification-title"
                        :class="[`text-danger`, { 'opacity-50': ntf.is_read }]"
                        >{{ ntf.license_plate }}</span
                      >
                      <small :class="{ 'opacity-50': ntf.is_read }">{{ ntf.event_name }}</small>
                    </div>
                  </div>
                  <small class="mt-1 whitespace-no-wrap" :class="{ 'opacity-50': ntf.is_read }">{{
                    elapsedTime(ntf.device_time)
                  }}</small>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div
              @click="navigateToAll"
              class="checkout-footer fixed pin-b rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid border-grey-light cursor-pointer">
              <span>{{ $t('View All Notification') }}</span>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- Profile Section -->
        <div class="navbar-item profile-section">
          <div class="profile-info">
            <div class="profile-avatar">
              <img
                :src="ProfilePic"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block" />
            </div>
            <div class="profile-details" v-if="userInfo">
              <span class="profile-name">{{ userInfo.name || 'User' }}</span>
              <span class="profile-role">{{
                (userInfo.role && userInfo.role.role_name) || 'Admin'
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapState } from 'vuex'
import ProfilePic from '../../assets/Icon-baru/AFMS-ProfilePic.png'
import moment from 'moment'
import * as REPO from '../../repository/index'
import { getAuthHeader } from '../../helper/main'

import en from '../../assets/images/flags/en.png'
import id from '../../assets/images/flags/id.png'

export default {
  name: 'TopNavbar',
  data() {
    return {
      languages: [
        { lang: 'English', flag: en, locale: 'en' },
        { lang: 'Indonesia', flag: id, locale: 'id' },
      ],
      ProfilePic: ProfilePic,
      userInfo: null,
      counter: '',
      data_notif: [],
      hideBtn: null,
      markingAsRead: false,
      manualCounterUpdate: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    }
  },
  mounted() {
    this.userInfo = this.currentUserInfo

    // Watch for notification changes
    let self = this
    this.$store.watch(
      (state) => state.notifData,
      (oldValue, newValue) => {
        // Only update counter from store if not manually set
        if (!this.manualCounterUpdate) {
          const storeCounter = self.$store.getters['getCounter']()
          console.log('🔍 DEBUG: Store watcher triggered - updating counter from', this.counter, 'to', storeCounter)
          this.counter = storeCounter
        } else {
          console.log('🔍 DEBUG: Store watcher blocked by manualCounterUpdate flag')
        }
        let listAlert = self.$store.getters['getHundredAlert']()
        this.data_notif = listAlert
      }
    )
  },
  computed: {
    currentUserInfo() {
      // Get user info from localStorage or store
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return (
        userInfo || {
          name: 'User',
          role: { role_name: 'Admin' },
        }
      )
    },
    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale
      return this.languages.find((x) => x.locale == locale)
    },
    // Navbar class based on sidebar state
    navbarClass() {
      const sidebarWidth = this.$store.state.sidebarWidth
      if (sidebarWidth === 'reduced') return 'navbar-reduced'
      if (sidebarWidth === 'no-sidebar') return 'navbar-full'
      return 'navbar-default'
    },
  },
  methods: {
    toggleSidebar() {
      // Set flag to indicate user manually triggered sidebar toggle
      this.$store.commit('SET_SIDEBAR_USER_TRIGGERED', true)

      // Use nextTick and force the toggle
      this.$nextTick(() => {
        const currentState = this.$store.state.isSidebarActive
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', !currentState)
      })
    },
    updateLocale(locale) {
      this.$i18n.locale = locale
    },
    navigateToAll() {
      this.$router.push('/alert-history')
    },
    
    async markAllAsRead() {
      this.markingAsRead = true
      try {
        const user_id = JSON.parse(localStorage.getItem('userInfo')).id
        const fleet_group_ids = JSON.parse(
          localStorage.getItem('userInfo')
        ).fleet_group_ids

        console.log('🔍 DEBUG: Starting markAllAsRead')
        console.log('🔍 DEBUG: user_id:', user_id)
        console.log('🔍 DEBUG: fleet_group_ids:', fleet_group_ids)
        console.log('🔍 DEBUG: data_notif count before:', this.data_notif.length)
        console.log('🔍 DEBUG: counter before:', this.counter)

        const requestData = {
          user_id: user_id,
          fleet_group_ids: user_id // Use user_id instead of fleet_group_ids array
        }
        
        console.log('🔍 DEBUG: Request data:', requestData)
        console.log('🔍 DEBUG: Token in localStorage:', localStorage.getItem('token'))
        console.log('🔍 DEBUG: Auth header:', getAuthHeader())
        
        const response = await REPO.markAllNotificationsAsRead(requestData)

        console.log('🔍 DEBUG: markAllAsRead API response:', response)
        console.log('🔍 DEBUG: Response data:', response.data)
        console.log('🔍 DEBUG: Response status:', response.status)

        // Mark all notifications as read locally instead of clearing them
        this.data_notif.forEach(notif => {
          notif.is_read = true
          notif.read_by = user_id
          notif.read_at = new Date().toISOString()
        })
        
        // Update counter to 0 since all notifications are now read
        this.counter = 0
        
        // Update store with marked notifications
        this.$store.dispatch('addNotifData', this.data_notif)
        this.$store.dispatch('updateCounter', 0)
        
        console.log('🔍 DEBUG: After marking as read - data_notif:', this.data_notif.length)
        console.log('🔍 DEBUG: After marking as read - counter:', this.counter)
        
        // Set flag to prevent counter update from store watcher temporarily
        this.manualCounterUpdate = true
        
        // Allow store watcher to update counter again after 2 seconds
        setTimeout(() => {
          this.manualCounterUpdate = false
          console.log('🔍 DEBUG: manualCounterUpdate flag reset to false')
        }, 2000)
      } catch (error) {
        console.error('🔍 DEBUG: Error marking notifications as read:', error)
        this.$toast.error('Gagal menandai notifikasi sebagai dibaca')
      } finally {
        this.markingAsRead = false
        console.log('🔍 DEBUG: markAllAsRead completed')
      }
    },
    elapsedTime(startTime) {
      let x = new Date(startTime)
      let now = new Date()
      var timeDiff = now - x
      timeDiff /= 1000

      var seconds = Math.round(timeDiff)
      timeDiff = Math.floor(timeDiff / 60)

      var minutes = Math.round(timeDiff % 60)
      timeDiff = Math.floor(timeDiff / 60)

      var hours = Math.round(timeDiff % 24)
      timeDiff = Math.floor(timeDiff / 24)

      var days = Math.round(timeDiff % 365)
      timeDiff = Math.floor(timeDiff / 365)

      var years = timeDiff

      if (years > 0) {
        return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
      } else if (days > 0) {
        return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `sec ago` : 'just now')
      }

      return 'Just Now'
    },
    getRolePermission() {
      // Get role permissions from localStorage or return default
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        return (
          userInfo.role_permission || {
            alert: {
              alert_history: { access_to_alert: true },
            },
          }
        )
      } catch (e) {
        return {
          alert: {
            alert_history: { access_to_alert: true },
          },
        }
      }
    },
  },
  components: {
    VuePerfectScrollbar,
  },
}
</script>

<style lang="scss">
.dropdown-red > .vs-dropdown--menu--after {
  background: #ea5354 !important;
}

// Position arrow to point at the flag icon (on the right)
::v-deep .navbar-right {
  // Language dropdown arrow positioning
  .vs-dropdown:not(.vs-dropdown[color="danger"]) {
    .vs-dropdown--menu {
      &::after,
      &::before {
        left: auto !important;
        right: 20px !important;
      }
    }

    .vs-dropdown--menu--after {
      left: auto !important;
      right: 20px !important;
    }
  }

  // Notification dropdown arrow positioning (if needed)
  .vs-dropdown[color="danger"] {
    .vs-dropdown--menu {
      &::after,
      &::before {
        left: auto !important;
        right: 30px !important;
      }
    }

    .vs-dropdown--menu--after {
      left: auto !important;
      right: 30px !important;
    }
  }
}

/* Notification styling */
.notification {
  transition: all 0.2s ease-in-out;
}

.notification-read {
  opacity: 0.5 !important;
  background-color: rgba(0, 0, 0, 0.02) !important;
  color: #999 !important;
}

.notification-read .feather {
  opacity: 0.6 !important;
}

.notification-read .text-sm,
.notification-read .text-xs {
  color: #999 !important;
}

/* Notification read/unread styling */
.notification-read {
  background: rgba(0, 0, 0, 0.02) !important;
  opacity: 0.7;
}

.notification:not(.notification-read) {
  background: rgba(238, 109, 109, 0.03);
  border-left: 3px solid #ee6d6d;
}

.notification {
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  margin: 2px 8px;
}

.notification:hover {
  background: rgba(238, 109, 109, 0.08) !important;
}

/* Mark as read button styling */
.notification-top .vs-button {
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  font-size: 11px !important;
  padding: 6px 12px !important;
  border-radius: 4px !important;
  transition: all 0.2s ease-in-out;
}

.notification-top .vs-button:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.notification-top .vs-button:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}
</style>

<style lang="scss" scoped>
.top-navbar {
  position: fixed;
  top: 0;
  left: 260px; // Default sidebar width
  right: 0;
  height: 64px;
  background: white;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: left 0.3s ease;

  // Adjust for different sidebar states
  &.navbar-default {
    left: 260px;
  }

  &.navbar-reduced {
    left: 80px;
  }

  &.navbar-full {
    left: 0;
  }

  .navbar-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
  }

  .navbar-left {
    display: flex;
    align-items: center;

    .hamburger-menu {
      display: none; // Hidden by default on desktop
      padding: 8px;
      border-radius: 8px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      svg {
        width: 24px;
        height: 24px;
        color: #4b5563;
      }
    }
  }

  .navbar-right {
    display: flex;
    align-items: center;
    gap: 16px;

    // Ensure dropdowns are clickable on mobile
    ::v-deep .vs-dropdown {
      position: relative;
      z-index: 1001;
    }

    ::v-deep .vs-dropdown--menu {
      z-index: 1002 !important;
    }

    .navbar-item {
      display: flex;
      align-items: center;

      &.notification-bell {
        .notification-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          background: #ef4444;
          color: white;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          font-size: 11px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
        }
      }

      &.profile-section {
        .profile-info {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 8px 16px;

          .profile-details {
            display: flex;
            flex-direction: column;

            .profile-name {
              font-size: 14px;
              font-weight: 600;
              color: #1f2937;
              line-height: 1.2;
            }

            .profile-role {
              font-size: 12px;
              color: #6b7280;
              line-height: 1.2;
            }
          }
        }
      }
    }
  }
}

// Tablet and below - Show hamburger menu
@media (max-width: 1200px) {
  .top-navbar {
    left: 0 !important;

    .navbar-left .hamburger-menu {
      display: block;
    }

    // Arrow positioning for tablet
    .navbar-right {
      ::v-deep .vs-dropdown {
        .vs-dropdown--menu {
          &::after,
          &::before {
            left: auto !important;
            right: 30px !important;
          }
        }

        .vs-dropdown--menu--after {
          left: auto !important;
          right: 30px !important;
        }

        // Language dropdown
        &:not([color="danger"]) {
          .vs-dropdown--menu {
            &::after,
            &::before {
              right: 35px !important;
            }
          }

          .vs-dropdown--menu--after {
            right: 35px !important;
          }
        }

        // Notification dropdown
        &[color="danger"] {
          .vs-dropdown--menu {
            &::after,
            &::before {
              right: 45px !important;
            }
          }

          .vs-dropdown--menu--after {
            right: 45px !important;
          }
        }
      }
    }
  }
}

// Mobile - Additional responsive adjustments
@media (max-width: 768px) {
  .top-navbar {
    left: 0 !important;
    height: 60px;

    .navbar-content {
      padding: 0 16px;
    }

    .navbar-left .hamburger-menu {
      display: block;
    }

    .navbar-right {
      gap: 8px;

      // Make dropdowns more touch-friendly on mobile
      ::v-deep .vs-dropdown {
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;

        .con-img {
          cursor: pointer;
          padding: 8px;
          margin: -8px;

          img {
            pointer-events: none;
          }
        }

        .vs-dropdown--menu {
          position: fixed !important;
          right: 16px !important;
          left: auto !important;
          top: 60px !important;
          max-height: 70vh;
          overflow-y: auto;

          // Arrow positioning on mobile - align to right side
          &::after,
          &::before {
            left: auto !important;
            right: 35px !important;
          }
        }

        .vs-dropdown--menu--after {
          left: auto !important;
          right: 35px !important;
        }

        // Adjust for language dropdown specifically
        &:not([color="danger"]) {
          .vs-dropdown--menu {
            &::after,
            &::before {
              right: 40px !important;
            }
          }

          .vs-dropdown--menu--after {
            right: 40px !important;
          }
        }

        // Adjust for notification dropdown - Center it
        &[color="danger"] {
          .vs-dropdown--menu {
            position: fixed !important;
            left: 50% !important;
            right: auto !important;
            transform: translateX(-50%) !important;
            width: calc(100vw - 32px) !important;
            max-width: 500px !important;

            &::after,
            &::before {
              left: 50% !important;
              right: auto !important;
              transform: translateX(-50%) !important;
            }
          }

          .vs-dropdown--menu--after {
            left: 50% !important;
            right: auto !important;
            transform: translateX(-50%) !important;
          }
        }
      }

      // Make bell icon more touch-friendly
      ::v-deep .feather-icon {
        cursor: pointer;
        padding: 8px;
        margin: -8px;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
      }

      .mr-5 {
        margin-right: 0.5rem !important;
      }

      .profile-section .profile-details {
        display: none; // Hide profile text on mobile
      }
    }
  }
}

// Extra small mobile
@media (max-width: 480px) {
  .top-navbar {
    .navbar-content {
      padding: 0 12px;
    }

    .navbar-right {
      gap: 4px;

      .mr-5 {
        margin-right: 0.25rem !important;
      }

      .ml-3 {
        margin-left: 0.5rem !important;
      }

      // Adjust language dropdown menu for very small screens
      ::v-deep .vs-dropdown:not([color="danger"]) .vs-dropdown--menu {
        right: 8px !important;
        left: 8px !important;
        width: auto !important;
        max-width: calc(100vw - 16px) !important;
      }

      // Notification dropdown stays centered on very small screens too
      ::v-deep .vs-dropdown[color="danger"] .vs-dropdown--menu {
        position: fixed !important;
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%) !important;
        width: calc(100vw - 16px) !important;
        max-width: 100% !important;
      }
    }
  }
}

// Fix for notification dropdown on mobile - Center it
@media (max-width: 768px) {
  .notification-dropdown {
    position: fixed !important;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    top: 60px !important;
    width: calc(100vw - 32px) !important;
    max-width: 500px !important;
    max-height: 70vh !important;
    overflow: hidden !important;

    .scroll-area--nofications-dropdown {
      max-height: calc(70vh - 200px) !important;
    }

    // Center the arrow
    .vs-dropdown--menu--after,
    &::after,
    &::before {
      left: 50% !important;
      right: auto !important;
      transform: translateX(-50%) !important;
    }
  }

  // Also apply to the parent dropdown menu class
  ::v-deep .vs-dropdown[color="danger"] .vs-dropdown--menu {
    position: fixed !important;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    top: 60px !important;
    width: calc(100vw - 32px) !important;
    max-width: 500px !important;
  }
}

// Force click behavior for dropdowns (override hover)
@media (max-width: 1200px) {
  ::v-deep .vs-dropdown {
    // Ensure dropdown opens on click not hover
    &:hover .vs-dropdown--menu {
      display: none !important;
    }

    &.vs-dropdown-active .vs-dropdown--menu {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      transform: translateY(0) !important;
    }
  }
}
</style>
